import daysLibrary from './libraries/days'
import randomInt from 'random-int'

/**
 * Omit the argument to get a random value
 * @return string
 * @param n
 */
const day = ( n = undefined ) => {
  let number = n || randomInt( 1, 7 )

  if ( typeof number !== 'number' ) {
    throw new TypeError( 'Invalid argument provided for a day' )
  }

  return daysLibrary[ number - 1 ]
}

export default day



// WEBPACK FOOTER //
// ./src/day.js